(function ($, win) {

  function setPaddings() {
    container_size = $('.container').width();
    container_size_2 = $('.full-container-2').width();
    screen_size = $(window).width();

    padding_contact = (screen_size - container_size_2) / 2;

    $('.page-template-template-contact .contact-details-wrapper .left').css('padding-left', padding_contact);
    $('.gallery-section .right').css('padding-right', padding_contact);
    $('.gallery-section .left').css('padding-left', padding_contact);
  }

  function setPagination() {

    if ($('.post-navigation').length > 0) {
      $('.post-navigation ul.page-numbers li a.prev')
        .parent('li')
        .addClass('prev-page');
      $('.post-navigation ul.page-numbers li a.next')
        .parent('li')
        .addClass('next-page');
      $('.post-navigation ul.page-numbers li a.prev').addClass('nav-button');
      $('.post-navigation ul.page-numbers li a.next').addClass('nav-button');
      if ($('.post-navigation ul.page-numbers li.prev-page').length === 0) {
        $('.post-navigation ul.page-numbers').prepend('<li class="prev-page off"><i class="icon-arrow"></i></li>');
      }
      if ($('.post-navigation ul.page-numbers li.next-page').length === 0) {
        $('.post-navigation ul.page-numbers').append('<li class="next-page off"><i class="icon-arrow"></i></li>');
      }
    }
  }

  $(document).ready(function () {

    var timer;


    $('.collapse').on('show.bs.collapse', function () {
      $(this).prev().addClass('active-acc');
    });

    $('.collapse').on('hide.bs.collapse', function () {
      $(this).prev().removeClass('active-acc');
    });

    $('#home-slider').on('changed.owl.carousel', function (e) {
      var index = e.item.index;

      if (index !== null) {
        $('#home-slider-wrapper .left .inner .content').hide();
        $('#home-slider-wrapper .left .inner .content')
          .eq(index)
          .fadeIn();
      }
    }).owlCarousel({
      animateIn: 'fadeIn',
      animateOut: 'fadeOut',
      rewind: true,
      loop: false,
      nav: true,
      dots: true,
      autoplay: true,
      autoplayTimeout: 5500,
      margin: 0,
      items: 1,
      slideBy: 1,
      navContainer: '#home-slider-nav',
      smartSpeed: 1000,
      navText: ['<i class="icon-chevron-1"></i>', '<i class="icon-chevron-1"></i>'],
      thumbs: false,
    });

    $('#home-news-slider')
      .on('initialized.owl.carousel', function () {
        $
          .fn
          .matchHeight
          ._update();
      })
      .owlCarousel({
        loop: true,
        nav: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 3500,
        margin: 15,
        navContainer: '#home-news-nav',
        navText: ['<i class="icon-chevron-1"></i>', '<i class="icon-chevron-1"></i>'],
        thumbs: false,
        smartSpeed: 1000,
        responsive: {
          992: {
            items: 2
          },
          1200: {
            items: 2
          },
          1710: {
            items: 3
          }
        }
      });


    $('#home-events-slider')
      .on('initialized.owl.carousel', function () {
        $
          .fn
          .matchHeight
          ._update();
      })
      .owlCarousel({
        loop: true,
        nav: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 3500,
        margin: 15,
        smartSpeed: 1000,
        navContainer: '#home-events-nav',
        navText: [
          '<i class="icon-chevron-1"></i>', '<i class="icon-chevron-1"></i>'
        ],
        thumbs: false,
        responsive: {
          992: {
            items: 2
          },
          1200: {
            items: 2
          },
          1710: {
            items: 3
          }
        }
      });

    $('#twitter-slider')
      .on('initialized.owl.carousel', function () { })
      .owlCarousel({
        loop: true,
        nav: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 6500,
        margin: 0,
        items: 1,
        smartSpeed: 1000,
        navContainer: '#twitter-slider',
        navText: ['<i class="icon-chevron-1"></i>', '<i class="icon-chevron-1"></i>'],
        thumbs: false
      });

    $('.sectionGallery').owlCarousel({
      loop: true,
      nav: true,
      dots: false,
      autoplay: false,
      margin: 0,
      items: 1,
      thumbs: true,
      thumbsPrerendered: true,
      navText: ['<i class="icon-chevron-1"></i>', '<i class="icon-chevron-1"></i>']
    });


    /*     $('.burger-btn').on('click', function () {
    $(this).toggleClass('opened');
    $('#mainHeader').toggleClass('menu-opened');
    $('#responsive-menu').fadeToggle('fast');
  }); */

    /*     $('.popup-youtube').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
    closeMarkup: '<span class="mfp-close">x</span>'
  }); */

    var inMegaMenu = false;
    var inMenuItem = false;

    $('.body-wrapper').on('mouseenter', '#megaMenu', function (event) {
      inMegaMenu = true;
    });

    $('.body-wrapper').on('mouseleave', '#megaMenu', function (event) {
      inMegaMenu = false;
      $(this).remove();
    });

    $('#mainHeader .topRow .headerTop .searchHolder > .icon-search').on('click', function () {
      $(this).hide();
      $('#mainHeader .topRow .headerTop .searchHolder .search-form').fadeIn();
    });

    $('#mainHeader .bottomRow .menu > li.menu-item-has-children > a').append('<i class="icon-dropdown-2"></i>');

    $('#mainHeader .bottomRow .menu > li.menu-item-has-children').on('mouseenter', function (event) {
      inMegaMenu = false;
      inMenuItem = true;

      if ($('#megaMenu').length > 0) {
        $('#megaMenu').remove();
      }

      //handlerIn
      $('#mainHeader').after('<div id="megaMenu"><div class="container"><div class="menuWrapper"></div><div class="nl-wrapper"></div></div></div>');
      $('#megaMenu .menuWrapper').append($(this).children('.sub-menu').clone());
      $('#megaMenu .menuWrapper >ul li.menu-item-has-children > a').append('<i class="icon-dropdown-2"></i>');

      $('#megaMenu .nl-wrapper').append($('#menu-newsletter').html());

      $('#megaMenu .menuWrapper a[href="#dropdown"]').on('click', function () {
        $(this).parent('li').children('.sub-menu').slideToggle();
      });
      $('#megaMenu').slideDown(150);
    });

    $('#mainHeader .bottomRow .menu > li.menu-item-has-children').on('mouseleave', function (event) {
      setTimeout(function () {
        if (false === inMegaMenu && false === inMenuItem) {
          $('#megaMenu').remove();
        }
      }, 200);

      inMenuItem = false;
    });




    $('#trusteeLogin')
      .on('submit', function (event) {
        event.preventDefault();

        $('#trusteeloginSubmitButton').hide();
        $('.lostpw').hide();
        $('.login-spinner').removeClass('d-none');
        $('.login-error-msg').addClass('d-none');

        $.ajax({
          url: ajaxurl,
          type: 'POST',
          dataType: 'json',
          data: {
            action: 'check_trustee_login',
            user_name: $('#trusteeLogin input[name="user_name"]').val(),
            user_pass: $('#trusteeLogin input[name="user_pass"]').val(),
            security: $('#trusteeLogin input[name="security"]').val()
          }
        })
          .done(function (res) {
            console.log(res);
            if (res.loggedin == false) {
              $('.login-error-msg').html(res.message);
              $('.login-error-msg').removeClass('d-none');
            } else {
              console.log('redirect');
              window.location.href = $('#trusteeLogin input[name="redirect_to"]').val();
            }
          })
          .fail(function (err) {
            $('.login-error-msg').html(JSON.stringify(err));
            $('.login-error-msg').removeClass('d-none');
          })
          .always(function () {

            $('#trusteeloginSubmitButton').show();
            $('.lostpw').show();
            $('.login-spinner').addClass('d-none');


          });

        console.log('submitted');

      });

    setPaddings();


    // $('.select2').select2({
    //   minimumResultsForSearch : Infinity
    // });

    // Auto-select date for booking and pre-fill date fields
    var selectedDate = $('#availableDates').val();

    if (selectedDate) {
      console.log(selectedDate);
      var selectedDateBreakdown = selectedDate.split('-');

      $("input[name*='wc_bookings_field_start_date_day']").val(selectedDateBreakdown[0]);
      $("input[name*='wc_bookings_field_start_date_month']").val(selectedDateBreakdown[1]);
      $("input[name*='wc_bookings_field_start_date_year']").val(selectedDateBreakdown[2]);

      $('.wc-bookings-booking-form-button').removeAttr("disabled");
    }

    $(document)
      .ajaxComplete(function () {
        // Remove 'Booking Cost:' from cost calculator
        var bookingCostText = $('#bookingCost .wc-bookings-booking-cost').text();

        if (bookingCostText) {
          var newBookingCostText = bookingCostText.replace(/Booking cost:/g, '');
          newBookingCostText = newBookingCostText.replace('Total:', site_texts.total);

          $('#bookingCost .wc-bookings-booking-cost').text(newBookingCostText);
        }

      });



    $('.buttonHolder .loadMore').on('click', function () {
      $(this).fadeOut();
      parent = $(this).closest('.full-container-2');
      current_shown = parent.find('.landing-pages-wrapper > .row > div.showed').length;
      max_elements = parent.find('.landing-pages-wrapper > .row > div').length;
      current_shown = (current_shown + 5 <= max_elements) ? (current_shown + 5) : max_elements;
      parent.find('.landing-pages-wrapper > .row > div:lt(' + current_shown + ')').addClass('showed');
      $.fn.matchHeight._update();
      if (current_shown !== max_elements) {
        $(this).fadeIn();
      }
    });


    $('.burger-btn').click(function () {
      $(this).toggleClass('active');
      $('#responsive-menu').slideToggle();
    });



    $('#responsive-menu .navigation > .menu > li > .sub-menu').each(function () {
      $(this).parent('li').append('<i class="icon-chevron-1"></i>');
      $(this).parent('li').after($(this));
    });


    $('#responsive-menu .navigation > .menu > li > i').click(function () {
      $(this).toggleClass('active');
      $(this).parent('li').next().slideToggle();
    });

    $('#responsive-menu a[href="#dropdown"]').click(function () {
      $(this).parent('li').children('.sub-menu').slideToggle();
    });

    // Reorder news and policy categories
    var cat_list = $("#cat-filters > ul > li");
    cat_list.sort(function (a, b) {
      return ($(b).data('order')) < ($(a).data('order')) ? 1 : -1;
    }).appendTo('#cat-filters .filters'); // append again to the list

    $('.nav > li > a').on('click', function (e) {
      e.preventDefault();
      var target = $(this).data('target');

      $('.tab-content > .tab-pane').fadeOut("fast", function () {
        $('.tab-content > .tab-pane').removeClass("show active");
      });

      $('#' + target).fadeIn("fast", function () {
        $('#' + target).addClass("show active");
      });

      $('.nav > li > a').removeClass("active");
      $('.nav > li > a#' + target + '-tab').addClass("active");

      if ($(this).hasClass('bottom')) {
        $("#tab-content-wrap").get(0).scrollIntoView({behavior: 'smooth'});
      }
    });

  });

  //Hide search when clicking outside container.
  $(document).on('click', function (e) {
    if ($(e.target).closest('#mainHeader .topRow .headerTop .searchHolder').length === 0) {
      $('#mainHeader .topRow .headerTop .searchHolder .search-form').hide();
      $('#mainHeader .topRow .headerTop .searchHolder .icon-search').show();
    }
  });

  $(window).on('load', function () {
    setPaddings();
    setPagination();
    $('.initial-hidden').css('opacity', 1);
  });

  $(window).on('resize', function () {
    setPaddings();
  });

  // Responsive video jquery from https://css-tricks.com/NetMag/FluidWidthVideo/Article-FluidWidthVideo.php
  // Find all YouTube videos
  var $allVideos = $("iframe[src*='youtube.com']");

  // The element that is fluid width
  var $fluidEl = $(".main-content");

  // Figure out and save aspect ratio for each video
  $allVideos.each(function () {
    $(this)
      .data('aspectRatio', this.height / this.width)
      // and remove the hard coded width/height
      .removeAttr('height')
      .removeAttr('width');
  });

  // When the window is resized
  $(window).resize(function () {
    var newWidth = $fluidEl.width();
    // Resize all videos according to their own aspect ratio
    $allVideos.each(function () {
      var $el = $(this);
      $el
        .width(newWidth)
        .height(newWidth * $el.data('aspectRatio'));
    });
    // Kick off one resize to fix all videos on page load
  }).resize();

})(jQuery, window); // Fully reference jQuery after this point.
